module.exports = __webpack_public_path__ + "img/app-store.78f90240.svg";